// extracted by mini-css-extract-plugin
export default {"main__row":"main-layout_main__row__r0OKY","mobile__nav":"main-layout_mobile__nav__g41i1","main__section":"main-layout_main__section__7-TLR"};